import React from "react"
// nodejs library that concatenates classes
import classNames from "classnames"
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles"
// core components
import Header from "../../components/Header/Header.jsx"
import Footer from "../../components/Footer/Footer.jsx"
import GridContainer from "../../components/Grid/GridContainer.jsx"
import GridItem from "../../components/Grid/GridItem.jsx"
import Button from "../../components/CustomButtons/Button.jsx"
import HeaderLinks from "../../components/Header/HeaderLinks.jsx"
import Parallax from "../../components/Parallax/Parallax.jsx"

import landingPageStyle from "../../assets/jss/material-kit-react/views/landingPage.jsx"
// Sections for this page
import logo from "../../assets/img/mibLogoCorrect.svg"
import InfoArea from "../../components/InfoArea/InfoArea"

// @material-ui/icons

const dashboardRoutes = []

class Faq extends React.Component {
    render() {
        const { classes, ...rest } = this.props
        return (
            <div>
                <Header
                    color="transparent"
                    routes={dashboardRoutes}
                    brand={<img style={{ width: "8rem", height: "3.5rem" }} src={logo} alt="" />}
                    rightLinks={<HeaderLinks />}
                    fixed
                    changeColorOnScroll={{
                        height: 200,
                        color: "white",
                    }}
                    {...rest}
                />
                <Parallax filter image={require("../../assets/img/mib-bg.jpg")}>
                    <div className={classes.container}>
                        <GridContainer
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                "@media (minWidth: 1200px)": {
                                    marginRight: "-50px",
                                    marginLeft: "-50px",
                                },
                            }}>
                            <GridItem xs={12} sm={12} md={7} style={{ textAlign: "center" }}>
                                <h1 className={classes.title} style={{ fontFamily: "Open Sans" }}>
                                    Bespoke{" "}
                                    <b>
                                        online ordering for <span style={{ color: "#FFC915" }}> your restaurant</span>
                                    </b>
                                </h1>
                                <h4 style={{ fontWeight: "500" }}>
                                    Your brand. Your customers. Your online ordering platform.
                                </h4>
                                <br />
                                <Button
                                    style={{
                                        width: "30%",
                                        textTransform: "none",
                                        fontSize: "0.9rem",
                                        padding: "0.7rem",
                                        fontFamily: "Open Sans",
                                    }}
                                    color="primary"
                                    size="sm"
                                    href="#learn"
                                    rel="noopener noreferrer">
                                    Try Now
                                </Button>
                            </GridItem>
                        </GridContainer>
                    </div>
                </Parallax>
                <div className={classNames(classes.main, classes.mainRaised)}>
                    <div className={classes.container}>
                        <GridContainer>
                            <GridItem xs={12} sm={12} md={12}>
                                <InfoArea
                                    title="Frequently asked questions"
                                    description={<span>Coming soon...</span>}
                                    vertical
                                />
                            </GridItem>
                        </GridContainer>
                    </div>
                </div>
                <Footer />
            </div>
        )
    }
}

export default withStyles(landingPageStyle)(Faq)



// WEBPACK FOOTER //
// ./src/views/Faq/Faq.jsx